const typeIcoImg = {
    normal: require('../../Images/type-icon/normal.svg').default,
    fighting: require('../../Images/type-icon/fighting.svg').default,
    flying: require('../../Images/type-icon/flying.svg').default,
    poison: require('../../Images/type-icon/poison.svg').default,
    ground: require('../../Images/type-icon/ground.svg').default,
    rock: require('../../Images/type-icon/rock.svg').default,
    bug: require('../../Images/type-icon/bug.svg').default,
    ghost: require('../../Images/type-icon/ghost.svg').default,
    steel: require('../../Images/type-icon/steel.svg').default,
    fire: require('../../Images/type-icon/fire.svg').default,
    water: require('../../Images/type-icon/water.svg').default,
    grass: require('../../Images/type-icon/grass.svg').default,
    electric: require('../../Images/type-icon/electric.svg').default,
    psychic: require('../../Images/type-icon/psychic.svg').default,
    ice: require('../../Images/type-icon/ice.svg').default,
    dragon: require('../../Images/type-icon/dragon.svg').default,
    dark: require('../../Images/type-icon/dark.svg').default,
    fairy:require('../../Images/type-icon/fairy.svg').default
}

export default typeIcoImg